import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export async function fillDetail() {
  $("#d-algemeen-naam").html(
    window.$catalog_planning_period_selectedRow.algemeenNaam
  );
  $("#d-algemeen-naam-tooltip").html(
    window.$catalog_planning_period_selectedRow.algemeenNaam
  );
  $("#d-algemeen-code").html(
    window.$catalog_planning_period_selectedRow.algemeenCode
  );
  $("#d-algemeen-omschrijving").html(
    window.$catalog_planning_period_selectedRow.omschrijving
  );
  $("#d-algemeen-omschrijving-tooltip").html(
    window.$catalog_planning_period_selectedRow.omschrijving
  );

  $("#d-algemeen-start-datum").attr(
    "placeholder",
    window.$catalog_planning_period_selectedRow.startdatum
  );
  $("#d-algemeen-eind-datum").attr(
    "placeholder",
    window.$catalog_planning_period_selectedRow.einddatum
  );

  if (window.$catalog_planning_period_selectedRow.flexibelinplannen)
    $("#d-algemeen-inplannen").attr("checked", "checked");
  else $("#d-algemeen-inplannen").removeAttr("checked");
  if (window.$catalog_planning_period_selectedRow.isActive)
    $("#d-algemeen-actief").attr("checked", "checked");
  else $("#d-algemeen-actief").removeAttr("checked");

  /**
   * * Edit side
   */
  $("#e-algemeen-naam").val(
    window.$catalog_planning_period_selectedRow.algemeenNaam
  );
  $("#e-algemeen-code").val(
    window.$catalog_planning_period_selectedRow.algemeenCode
  );
  $("#e-algemeen-omschrijving").val(
    window.$catalog_planning_period_selectedRow.omschrijving
  );

  var startDate = String(
    window.$catalog_planning_period_selectedRow.basestartdatum.replaceAll(
      "-",
      "/"
    )
  );
  startDate =
    startDate.split("/")[1] +
    "/" +
    startDate.split("/")[0] +
    "/" +
    startDate.split("/")[2];
  var endDate = String(
    window.$catalog_planning_period_selectedRow.baseeinddatum.replaceAll(
      "-",
      "/"
    )
  );
  endDate =
    endDate.split("/")[1] +
    "/" +
    endDate.split("/")[0] +
    "/" +
    endDate.split("/")[2];
  startDate = new Date(startDate);
  endDate = new Date(endDate);

  document.getElementById("e-startDate").value = GC.FormatDateReverse(
    startDate,
    "date"
  );
  document.getElementById("e-endDate").value = GC.FormatDateReverse(
    endDate,
    "date"
  );

  if (window.$catalog_planning_period_selectedRow.flexibelinplannen)
    $("#e-algemeen-inplannen").attr("checked", "checked");
  else $("#e-algemeen-inplannen").removeAttr("checked");
  if (window.$catalog_planning_period_selectedRow.isActive)
    $("#e-algemeen_active").attr("checked", "checked");
  else $("#e-algemeen_active").removeAttr("checked");

  $("#e-identification").val(
    window.$catalog_planning_period_selectedRow.identification
  );
}

export function GetColumnProperties(callType) {
  omnimap
    .GetColumnPropertiesAction(window.$catalog_management_units_token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesCallBack(result, callType);
      // fillDetail();
    });
}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {
  omnimap
    .OmnimapPost(model, pageNr, pageSize, token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesForModelCallBack(
        result,
        itemId,
        callType
      );
    })
    .catch((error) => {
      console.log(error);
    });
}

export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  window.$catalog_planning_period_selectedIds.forEach(async (element) => {
    let realtions = await omnimap.GetRelationAction(
      element,
      1,
      30,
      window.$catalog_management_units_token
    );

    if (realtions.data !== undefined) {
      await realtions.data.forEach(async (relation) => {
        let result = await omnimap
          .DeleteRelationAction(
            relation.identification,
            window.$catalog_management_units_token
          )
          .catch((error) => {
            console.log(error);
          });
        var test = "";
      });
    }

    GC.sleep(2000).then(async () => {
      let result = await omnimap
        .Delete(element, window.$catalog_management_units_token)
        .catch((error) => {
          console.log(error);
        });

      CallBackFunctions.RowsDeletedCallBack(
        window.$catalog_management_units_token
      );
    });
  });
};

export const GetMedia = (rowId) => {
  return new Promise(function (resolve, reject) {
    fetch(
      `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/media/${rowId}/content`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + window.$catalog_management_units_token,
          tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
          organisation_identification:
            process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
        },
      }
    )
      .then((response) => response.blob())
      .then((images) => {
        // Then create a local URL for that image and print it
        var outside = URL.createObjectURL(images);
        // this.setState({ gettingMedia: outside });
        resolve(outside);
      })
      .catch((err) => alert(err));
  });
};
